/**
 * Application configuration from environment variables.
 * @agentic @benchmark/config
 */
export const CONFIG = {
  VITE_EXTERNAL_AUTH_URL: import.meta.env.VITE_EXTERNAL_AUTH_URL,
  VITE_GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
  VITE_EXTERNAL_CLIENT_ID: import.meta.env.VITE_EXTERNAL_CLIENT_ID,
  VITE_EXTERNAL_REDIRECT_URI: import.meta.env.VITE_EXTERNAL_REDIRECT_URI,
  VITE_MEDPLUM_PROJECT_ID: import.meta.env.VITE_MEDPLUM_PROJECT_ID,
  VITE_MEDPLUM_CLIENT_ID: import.meta.env.VITE_MEDPLUM_CLIENT_ID,
  VITE_WEB_REDIRECT_URI: import.meta.env.VITE_WEB_REDIRECT_URI,
  VITE_BENCHMARK_ORGANIZATION_ID: import.meta.env
    .VITE_BENCHMARK_ORGANIZATION_ID,
};
